import { dispatchProps } from '../../cnr/reducers/reducerHelpers/dispatchProps';
import { _settingsFs } from '../../viewSettings/actions/getSettings';
import { createRefPath_client, createRefPath } from '../appData/appRefPaths';

export const createSimpleEvent = (database_fns, dispatch, paps_state, createInfo) => {

  const { initProps } = createInfo ?? {}
  const { dataCollections } = initProps ?? {}
  const { event } = dataCollections ? dataCollections : {}

  if (event) {
    const { pathViews } = paps_state ?? {}
    const _eventPath = createRefPath_client(pathViews, ['events'])
    database_fns.add_doc(_eventPath, event).then(res => {
      const { global, viewItems, views } = createInfo
      const settingsData = { global, viewItems, views }
      const _settingsPath = createRefPath([_settingsFs.root, res.id])
      database_fns.set_doc(_settingsPath, settingsData, false, dispatch)
    })
  } else {
    dispatch({ type: dispatchProps.error });
  }
}